import { Input, Loader, Button, convertCentsToDollars } from "@thdinc/hpf-shared";
import React, { useEffect, useState } from "react";
import SelectSearch from "react-select-search";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import { ingredientInterface } from "@/pages/company/interface";
import { FaCirclePlus } from "react-icons/fa6";
import FormModal from "@/components/modals/FormModal";
import deleteIcon from "../../../assets/icons/deleteIcon.svg";
import { COCKTAILS_TYPES_DATA } from "@/constants/CompanyData";
import Select, { components } from 'react-select'
import { FaInfoCircle } from "react-icons/fa";
import StyledSelect from "@/components/StyledSelect/StyledSelect";
import infoIcon from "../../../assets/images/info.png";
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import Alert from "@/components/alert/Alert";
interface product {
  name: string;
  value: string;
  type: string;
}

interface AddCocktailIngredients {
  type: string;
  product_type: string;
  spirit_type?: string;
  name?: string;
  qty_oz: string;
  other?: boolean;
  product_id?: string | null;
}
interface Props {
  productsList: product[];
  CurInggrediant?: ingredientInterface[];
  saveCocktail: (list: AddCocktailIngredients[]) => void;
  loading: boolean;
  prev?: () => void;
  isNew?: boolean;
  isCustomCocktail?: boolean;
  setNewIngredientFn?: (any: any) => void;
  businessId?: string | null;
  selectedType?: string
}
const IngrediantsBTC: React.FC<Props> = ({
  productsList,
  saveCocktail,
  CurInggrediant,
  loading,
  prev,
  isNew,
  setNewIngredientFn,
  isCustomCocktail,
  businessId,
  selectedType
}) => {
  const dispatch = useDispatch();
  const [updatedProductList, setUpdatedProductList] = useState<product[]>([]);
  const [mixersAndSyrupList, setMixerAndSyrupList] = useState<product[]>([]);
  const [ingList, setIngList] = useState<AddCocktailIngredients[]>([]);
  const [other, setOther] = useState<{ id: number; state: boolean }>();
  const [productName, setProductName] = useState<string>("");
  const { refreshToken } = useAppSelector((store) => store.user);
  const [perfferedProduct, setPerfferedProduct] = useState([])
  // const [qty, setQty] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [ingTotal, setIngTotal] = useState<number>(0);
  const defaultInputs = 5 // no of open ingredient fields
  const producIds = updatedProductList.map((p) => p.value);
  const { productsPreferences, productMixers } = API_ROUTES;
  const defaultIng = { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" } // default emppty ingredient
  const TYPES = [
    { value: 'Alcohol', name: 'Alcohol' },
    { value: 'Mixers/Syrups', name: 'Mixers/Syrups' }
  ]
  useEffect(() => {
    const newList = isCustomCocktail
      ? productsList
      : [...productsList, { value: "Other", name: "other", type: "other" }];
    setUpdatedProductList(newList);
    // const mixersAndSyrups = productsList.filter(p => p.type == 'mixers' || p.type == 'syrups')
    // setMixerAndSyrupList(mixersAndSyrups)
  }, []);
  useEffect(() => {
    (async () => {
      try {
        const res = await GET(`${productMixers}`, refreshToken);
        if (res?.data) {
          const struturedList = res.data.map((p: any) => {
            return { name: p.name, value: p.id, type: p.type }
          })
          setMixerAndSyrupList([...struturedList, { value: "other", name: "Other", type: "other" }])
        } else {
          setMixerAndSyrupList([])
        }
      } catch (error) {
        Alert({ type: 'error', message: 'Unable to fetch product' });
      }
    })();
  }, []);
  useEffect(() => {
    // update selected ingrediants if user select toggle filtered ings on the base of currrent products
    // if (isCustomCocktail) {
    //   const updated = ingList.filter((ing) => {
    //     // filter where selected ing is in filtered product
    //     if (ing.product_id !== '' && producIds.includes(ing.product_id as string)) {
    //       return ing
    //     }
    //     // or keep the input ingrediant input as it is
    //     else if (ing.product_id === '' || ing.product_id === null) {
    //       return ing
    //     }
    //   })
    //   setIngList(updated)
    // }
    setIngList([
      { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
      { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
      { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
      { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
      { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
    ]);
  }, [isCustomCocktail])
  useEffect(() => {
    if (isCustomCocktail) {
      setIngList([
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
      ]);
    }

  }, [selectedType])
  useEffect(() => {
    if (CurInggrediant && CurInggrediant?.length > 0) {
      const currentIng = CurInggrediant.map((i: any) => {
        const productName = productsList.filter(p => p.value == i.product_id).length > 0 ? i.name : ''
        return {
          ...i,
          qty_oz: i.qty_oz / 100,
          other: i.product_id ? false : true,
          type: i.spirit_type == 'mixers' || i.spirit_type == 'syrups' ? 'Mixers/Syrups' : 'Alcohol',
          //handle spiritType other type senerio
          product_type:
            i.product_type == null || i.product_type == "null" ? "other" :
              i.product_type == 'mixers' || i.product_type == 'syrups' ? i.product_id : i.product_type,
          spirit_type: i.spirit_type == null || i.spirit_type == "null" ? i.product_type : i.spirit_type,
          ...((i.product_id && !['syrups', 'mixers'].includes(i.spirit_type)) && { name: productName })
        };
      })
      // add default inputs if ing list less than 5
      if (currentIng.length < 5) {
        const extra = defaultInputs - CurInggrediant.length
        for (let index = 0; index < extra; index++) {
          currentIng.push(defaultIng)
        }
      }
      setIngList(currentIng)
    } else {
      setIngList([
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
        { qty_oz: "", name: "", product_id: "", other: false, type: "", product_type: "" },
      ]);
    }
  }, [CurInggrediant]);
  useEffect(() => {
    setNewIngredientFn && setNewIngredientFn(ingList);
  }, [ingList]);
  useEffect(() => {
    const totalIgredients = () => {
      const total = ingList.reduce((acc, cur) => {
        if (cur.qty_oz !== "" && parseFloat(cur.qty_oz) > 0 && parseFloat(cur.qty_oz) <= 15) {
          return acc + parseFloat(cur.qty_oz);
        }
        return acc;
      }, 0);
      setIngTotal(total);
    };
    totalIgredients();
  }, [ingList]);
  useEffect(() => {
    (async () => {
      try {
        const res = await GET(`${productsPreferences}/by-business/${businessId}`, refreshToken);
        if (res?.data?.length > 0) {
          setPerfferedProduct(res?.data)
        }
      } catch (error) {
        Alert({ type: 'error', message: 'Unable to fetch product preferences' });
      }
    })();
  }, []);
  /* istanbul ignore next */
  const handleChange = (selectedOption: any, id: number, selectionType: string) => {
    dispatch(formStateChange(true));
    if (selectedOption === "other") {
      setOther({ id, state: true });
    } else {
      setOther({ id, state: false });
      setProductName("");
    }
    const product: any = perfferedProduct.find((p: any) => [p.prefer1?.id, p.prefer2?.id, p.prefer3?.id].includes(selectedOption.value))
    const findProduct = productsList.find((p) => p.value == (selectionType == 'brand' ? selectedOption.value : selectedOption));
    const findMixesProduct = mixersAndSyrupList.find((p) => p.value == (selectionType == 'brand' ? selectedOption.value : selectedOption));
    const updated = ingList.map((p, index) => {
      if (index === id) {
        if (selectionType === 'type') {
          // Reset both product_type and brand when type changes
          return {
            ...p,
            type: selectedOption,
            product_type: "",
            product_id: "",
            name: "",
            other: false,
          };
        }
        if (selectionType === 'product_type') {
          if (p.type === 'Mixers/Syrups') {
            return {
              ...p,
              product_id: selectedOption === "other" ? null : selectedOption,
              name: selectedOption === "other" ? "" : findMixesProduct?.name ?? "",
              other: selectedOption === "other" ? true : false,
              spirit_type: selectedOption === "other" ? "mixers" : findMixesProduct?.type,
              product_type: findMixesProduct?.type
            };
          } else {
            return {
              ...p,
              product_type: findProduct?.value === selectedOption ? findProduct?.type : selectedOption,
              spirit_type: selectedOption,
              name: findProduct?.name ?? "",
              product_id: selectedOption,
              other: false,
            };
          }
        }
        if (selectionType === 'brand') {
          if (isCustomCocktail) {
            return {
              ...p,
              product_id: selectedOption.value === "other" ? null : selectedOption.value,
              name: findProduct?.name ?? productName,
              preferred: product ? true : false,
              other: selectedOption.value === "other" ? true : false,
              spirit_type: findProduct?.type,
            };
          } else {
            return {
              ...p,
              product_id: selectedOption.value === "other" ? null : selectedOption.value,
              name: findProduct?.name ?? productName,
              preferred: product ? true : false,
              other: selectedOption.value === "other" ? true : false,
            };
          }
        }
        return p;
      }
      return p;
    });
    setIngList(updated);
  };
  /* istanbul ignore next */
  const removeIngredient = (index: number) => {
    dispatch(formStateChange(true));
    // remove ingredient from the list
    const list = [...ingList];
    list.splice(index, 1);
    setIngList(list);
  };
  /* istanbul ignore next */
  const saveClicked = () => {
    // vali
    ingList.map((i) => {
      if (i.qty_oz !== "") {
        setError("");
      }
    });
    const filtered = ingList.filter((i) => {
      if (
        i.qty_oz !== "" &&
        parseFloat(i.qty_oz) > 0 &&
        parseFloat(i.qty_oz) <= 15
      ) {
        return i;
      }
    });
    if (filtered.length === 0) {
      setError("Please add ingrdients");
    } else {
      if (isCustomCocktail && filtered.length > 1) {
        Alert({
          type: "error",
          message: "Only one ingredient allowed in custom cocktail",
        });
        return
      }
      const isbrandNameEmpty = filtered.filter(ingredient => !ingredient.name)
      const isSpiritTypeEmpty = filtered.filter(ingredient => !ingredient.spirit_type)
      const isTypeExist = isbrandNameEmpty.some((item: AddCocktailIngredients) => item.spirit_type)
      if (isbrandNameEmpty.length > 0) {
        Alert({
          type: "error",
          message: `${isTypeExist ? 'Brand' : 'Type'} is required.`,
        });
        return
      }
      if (isSpiritTypeEmpty.length > 0) {
        Alert({
          type: "error",
          message: "Spirit Type is required.",
        });
        return
      }
      saveCocktail(filtered);
    }
  };
  const handleOnBlurOz = (
    e: React.ChangeEvent<HTMLInputElement>,
    ingIndex: number
  ) => {
    const updated = ingList.map((p, index) => {
      if (index === ingIndex) {
        p.qty_oz = e.target.value;
        // Update the brand name if update
        if (p.other) {
          p.name = productName
        }
      }
      return p;
    });
    setIngList(updated);
  };
  const updateOtherNameFun = (name: string, i: number) => {
    setProductName(name)
    setIngList(ingList.map((ing, index) => {
      if (index === i) {
        ing.name = name
      }
      return ing
    }))
  }
  const sortPreferredFirst = (list: product[]) => {
    const preferredIds = new Set(
      (perfferedProduct as any[]).map((p) => p.prefer1?.id).filter(Boolean)
    );
    return [...list].sort((a, b) => {
      const aIsPreferred = preferredIds.has(a.value) ? 1 : 0;
      const bIsPreferred = preferredIds.has(b.value) ? 1 : 0;
      return bIsPreferred - aIsPreferred;
    });
  }
  const handleBrandOption = (ing: AddCocktailIngredients) => {
    if (isCustomCocktail) {
      return sortPreferredFirst(productsList.filter(p => p.type === selectedType))
        .map(p => ({ label: p.name, value: p.value }))
    }
    return sortPreferredFirst(updatedProductList.filter(p => p.type === ing.product_type))
      .map(p => ({ label: p.name, value: p.value }))
  }
  const HandlePopUp = ({ productId }: { productId: string | null | undefined }) => {
    const product: any = perfferedProduct.find((p: any) => p.prefer1?.id === productId);
    if (!product || product?.bonus == 0) return null;
    return (
      <Popover key={productId} className="relative w-full">
        <PopoverButton>
          <div className="pt-[8px]">
            <img src={infoIcon} className="w-4 h-4" />
          </div>
        </PopoverButton>
        <PopoverPanel className="absolute z-10 bg-white">
          <div className="bg-white flex flex-row shadow-lg p-2 rounded">
            <p className="text-[13px]">{`Get a ${(product?.bonus / 100)}% Bonus for choosing this alcohol product.`}</p>
          </div>
        </PopoverPanel>
      </Popover>
    );
  };

  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <div className="flex justify-between items-center">
          <p>
            Ingredients
            {ingTotal > 0 && (
              <span className="bg-primary-red py-1 px-2 rounded-lg text-white text-[12px] ml-2">
                {ingTotal.toFixed(2)}
              </span>
            )}
          </p>
        </div>
        <div>
          {ingList.map((ing: AddCocktailIngredients, i: number) => {
            return (
              <div
                className="p-3 flex sm:flex-row lg:flex-nowrap flex-wrap flex-col justify-center items-end w-full gap-2"
                key={i}>
                <div className="w-full">
                  <p className="mb-2">Type</p>
                  <SelectSearch
                    options={isCustomCocktail ? TYPES.filter(type => type.value == 'Alcohol') : TYPES}
                    value={ing.type}
                    onChange={(e) => handleChange(e, i, 'type')}
                    data-testid="search-id"
                    search={false}
                    placeholder={"Select Type"}
                  />
                </div>
                {ing.type &&
                  <>
                    <div className="w-full">
                      <p className="mb-2">{ing.type == 'Mixers/Syrups' ? 'Mixers/Syrups Type' : 'Spirit Type'}</p>
                      {
                        isCustomCocktail ?
                          <SelectSearch
                            disabled={true}
                            options={COCKTAILS_TYPES_DATA.filter(item => item.name !== 'Other')}
                            value={
                              productsList.length > 0
                                ? COCKTAILS_TYPES_DATA.find(p => p.value === selectedType)?.value ?? ''
                                : ''
                            }
                            placeholder={"Select Product"}
                          />
                          :
                          <SelectSearch
                            options={ing.type == 'Mixers/Syrups'
                              ? mixersAndSyrupList
                              : COCKTAILS_TYPES_DATA.filter(item => item.name !== 'Other')}
                            value={
                              ing.type === 'Mixers/Syrups'
                                ? ing.product_id === null ? ing.product_type : ing.product_id
                                : ing.product_id === null ? ing.spirit_type : ing.product_type
                            }
                            onChange={(e) => {
                              handleChange(e, i, 'product_type')
                            }}
                            data-testid="search-id"
                            search
                            placeholder={"Select Product"}
                          />}
                    </div>
                    {ing.type == 'Alcohol' && <div className="w-full">
                      <div className=" flex flex-row items-center mb-2 gap-2">
                        <p>Brand</p>
                        <HandlePopUp key={i} productId={ing?.product_id} />
                      </div>
                      <StyledSelect
                        key={`${i}-${ing.product_type}`}
                        options={
                          handleBrandOption(ing)
                        }
                        value={handleBrandOption(ing).find(opt => opt.value === (ing.other ? "other" : ing.product_id))}
                        onChange={(e) => handleChange(e, i, 'brand')}
                        data-testid="search-id"
                        placeholder={"Select Brand"}
                        isCustomComponent
                        preferedProduct={perfferedProduct}
                      />
                    </div>}
                    <div className={`${ing.other && 'w-full'}`}>
                      {ing.other && (
                        <div className="w-full  ">
                          <p className="mb-2 min-w-36">{ing.type == 'Mixers/Syrups' ? 'Name' : 'Brand Name'}</p>
                          <Input
                            key={i}
                            className="w-full px-4 py-2 bg-p-gray rounded-full  h-12 focus:outline-none min-w-36 focus:ring-1 focus:ring-primary-red text-gray-600"
                            maxLength={50}
                            defaultValue={ing.name}
                            onChange={(e) => {
                              updateOtherNameFun(e.target.value, i)
                              setProductName(e.target.value);
                            }}
                            placeholder="Name"
                          />
                        </div>

                      )}
                    </div>
                  </>}
                <div className="w-full flex flex-col">
                  <p className="mb-2">Quantity (oz)</p>
                  <Input
                    onChange={(e) => handleOnBlurOz(e, i)}
                    className="w-full px-4 py-2 bg-p-gray rounded-full h-12 text-sm focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                    type="number"
                    min={1}
                    value={ing.qty_oz}
                    placeholder="Quantity (oz)"
                  // onChange={(e: any) => setQty(e.target.value)}
                  />
                  {parseFloat(ing.qty_oz) <= 0 && (
                    <p className="text-xs text-primary-red">{"Invalid value"}</p>
                  )}
                  {parseFloat(ing.qty_oz) > 15 && (
                    <p className="text-xs text-primary-red">
                      {"Quantity must not be greater than 15"}
                    </p>
                  )}
                </div>
                <div className="w-full lg:w-auto flex justify-end">
                  <div onClick={() => { removeIngredient(i) }}
                    className={`cursor-pointer p-2 bg-p-gray rounded-full font-bold`}
                    data-testid="delete-icon">
                    <img
                      src={deleteIcon}
                      width={20}
                      className="min-w-[14px] w-[14px]"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div
          data-testid="add-ingredient-btn"
          onClick={() => setIngList([...ingList, { qty_oz: "", other: false, type: "", product_type: "" }])}
          className=" inline-block cursor-pointer"
        >
          <FaCirclePlus className="cursor-pointer text-gray-400 text-xl ml-4 " />
        </div>

        {error && <p className="text-sm text-primary-red">{error}</p>}
      </div>
      <div className="flex justify-end mt-8 gap-4">
        <Button
          classes={
            "bg-primary-red text-white hover:bg-primary-red-button-hover "
          }
          disabled={loading}
          onClick={saveClicked}
        >
          {loading ? <Loader data-testid="loader" color="bg-gray-50" /> : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default IngrediantsBTC;
